import "../css/header.scss";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);

  useEffect(() => {
    const closeMore = (event) => {
      if (moreRef.current && !moreRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener("mousedown", closeMore);
    return () => document.removeEventListener("mousedown", closeMore);
  }, []);

  const toTop = () => {
    setMoreOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-left"></div>

        <div className="header-center">
          <Link to="/" onClick={toTop}>
            <img
              src="/head/cewillowmarket-logo.svg"
              alt="Cewillow Market"
              className="logo-img"
            />
          </Link>
        </div>

        <div className="header-right">
          <Link to="/cartpage" className="icon-btn cart-btn" aria-label="Cart">
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="none"
              width={20}
              height={20}
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="var(--icon-stroke-width)"
                d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"
              />
            </svg>
          </Link>
        </div>
      </div>

      <nav className="header-nav">
        <Link to="/shop" onClick={toTop}>
          New Arrivals
        </Link>
        <Link to="/about" onClick={toTop}>
          Our Story
        </Link>
        <Link to="/contact" onClick={toTop}>
          Contact Us
        </Link>

        <Link to="/" onClick={toTop}>
          Home
        </Link>
        <div className="header-more" ref={moreRef}>
          <button
            type="button"
            aria-expanded={moreOpen}
            aria-haspopup="true"
            onClick={() => setMoreOpen((open) => !open)}
          >
            More <span aria-hidden="true">{moreOpen ? "−" : "+"}</span>
          </button>
          {moreOpen && (
            <div className="header-more__menu">
              <Link to="/faqs" onClick={toTop}>FAQs</Link>
              <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
              <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
              <Link to="/terms" onClick={toTop}>Terms of Service</Link>
              <Link to="/returns" onClick={toTop}>Returns & Exchanges</Link>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Header;
